<template>
  <div>
    <b-modal
      :id="modalName"
      no-close-on-backdrop
      no-close-on-esc
      centered
      hide-header
      hide-footer
      hide-header-close
      hide-backdrop
      size="lg"
      content-class="test-result-modal-content-styles"
      body-class="test-result-modal-body-styles"
    >
      <b-overlay :show="wait">
        <div class="modal-container">
          <div id="header" class="header">
            <div class="info">
              <span style="font-size: 30px;">
                <span v-if="mode === 'LEARNNEW' || mode === 'REVIEW' || mode === 'FORCEREVIEW'" style="color: aquamarine">{{chosenGlossaryName}} </span>
                {{$t('Vocabulary.testJudge')}}
              </span>
            </div>
            <div class="info">
              <div v-html="highlight('日期' + $t('Common.colon') + nowDate)"></div>
              <div v-html="highlight($t('Vocabulary.range')+ $t('Common.colon') + wordRange)"></div>
              <div v-html="highlight($t('Common.score') + $t('Common.colon') + score)"></div>
              <div v-html="highlight($t('Vocabulary.usedTime')+ $t('Common.colon') + timeElapsed)"></div>
            </div>
          </div>
          <div id="body" class="body">
            <vueCustomScrollbar class="scroll-area">
              <b-table striped hover :fields="fields" :items="result" fixed class="result-table">
                <template v-slot:table-colgroup="scope">
                  <col
                    v-for="field in scope.fields"
                    :key="field.key"
                    :style="{ width: field.key === 'seq' || field.key === 'correctOrNot' ? '80px' : '200px' }"
                  />
                </template>
                <template v-slot:cell(question)="row">
                  <div v-if="!isExam || (isExam && currentExam && currentExam.modeCode === 4)">
                    <div v-if="row.item.seq-1 < wordListLength / 2">
                      <span>{{ row.item.question }}</span>
                    </div>
                    <div v-else>
                      <b-icon-volume-up-fill @click="playAudio(row.item.question)"></b-icon-volume-up-fill>
                    </div>
                  </div>
                  <div v-else-if="isExam">
                    <div v-if="currentExam && currentExam.modeCode === 1">
                      <span>{{ row.item.question }}</span>
                    </div>
                    <div v-if="currentExam && currentExam.modeCode === 2">
                      <b-icon-volume-up-fill @click="playAudio(row.item.question)"></b-icon-volume-up-fill>
                    </div>
                    <div v-if="currentExam && currentExam.modeCode === 3">
                      <span>{{ row.item.question.meaning }}</span>
                      &nbsp;
                      <b-icon-volume-up-fill @click="playAudio(row.item.question.pronunciation)"></b-icon-volume-up-fill>
                    </div>
                  </div>
                </template>
                <template v-slot:cell(correctOrNot)="row">
                  <b-icon
                    v-if="row.item.correctOrNot === true"
                    icon="check"
                    scale="2"
                    variant="success"
                  ></b-icon>
                  <b-icon v-else icon="x" scale="2" variant="danger"></b-icon>
                </template>
              </b-table>
            </vueCustomScrollbar>
          </div>
          <div id="footer" class="footer">
            <!-- <div v-if="leave" class="footer-items">
              <b-button class="custom-button four" @click="leaveHandler">{{ $t('Common.endAndLeave') }} <br/> (b)</b-button>
              <b-button class="custom-button four" @click="cancelModal">{{ $t('Common.cancel') }} <br/> (c)</b-button>
            </div>-->
            <div v-if="mode === 'LEARNNEW' || mode === 'REVIEW' || mode === 'FORCEREVIEW'">
              <div v-if="unknownListLength === 0 && score === 100" class="footer-items">
                <b-button
                  class="custom-button four"
                  style="margin-top: 25px;"
                  @click="nextStep"
                >{{ $t('Vocabulary.nextRound') }} (n)</b-button>
              </div>
              <div v-else class="footer-items">
                <span
                  style="margin: 10px 0px;"
                >{{$t('Vocabulary.goToPractice', [unknownListLength])}}</span>
                <b-button
                  class="custom-button four"
                  @click="nextStep"
                >{{ $t('Common.nextStep') }} (n)</b-button>
              </div>
            </div>
            <div v-else-if="mode === 'EXAMSIMULATION' || mode === 'EXAM'">
              <b-button
                class="custom-button four"
                @click="nextStep"
              >{{ $t('Common.confirm') }} (n)</b-button>
            </div>
          </div>
        </div>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import vueCustomScrollbar from 'vue-custom-scrollbar'
import SafeAudio from '../../../util/SafeAudio'
import { secondToHMS } from '../../../util/time'
import { highlightNumber } from '../../../util/highlight'
import Timer from '../../../util/Timer'
import { MODES } from '../vocabularyMode'
import moment from 'moment'

export default {
  name: 'TestResultModal',
  components: {
    vueCustomScrollbar
  },
  props: {
    modalName: {
      type: String,
      required: true
    },
    timer: {
      type: Timer,
      required: true
    },
    showQuestionnaireModal: {
      type: Function,
      required: true
    },
    showNotifyCompleteModal: {
      type: Function,
      required: true
    },
    showPracticeView: {
      type: Function,
      required: true
    },
    resetTimer: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      fields: [
        {
          key: 'seq',
          label: this.$t('Vocabulary.numberOfQuestions'),
          class: 'text-left'
        },
        { key: 'question', label: '', class: 'text-left' },
        {
          key: 'correctAnswer',
          label: this.$t('Vocabulary.correctAnswer'),
          class: 'text-center'
        },
        {
          key: 'inputAnswer',
          label: this.$t('Vocabulary.yourAnswer'),
          class: 'text-center'
        },
        {
          key: 'correctOrNot',
          label: this.$t('Vocabulary.correctOrIncorrect'),
          class: 'text-center'
        }
      ]
    }
  },
  computed: {
    ...mapState({
      isUpgraded: (state) => state.vocabularyPractice.isUpgraded,
      wait: state => state.glossary.waitForFetching,
      leave: state => state.vocabularyPractice.leave,
      result: state => state.vocabularyPractice.testJudgeResult,
      sortedResult: state => state.vocabularyPractice.sortedTestJudgeResult,
      score: state => state.vocabularyPractice.testScore,
      wordListLength: state => state.vocabularyPractice.testWordList.length,
      unknownListLength: state => state.vocabularyPractice.unknownList.length,
      chosenGlossary: state => state.glossary.chosenGlossary,
      glossaryList: state => state.glossary.glossaryList,
      mode: state => state.vocabularyPractice.mode,
      currentExam: state => state.exam.currentExam,
      userGradeCode: state => Number(state.auth.currentUser.gradeId)
    }),
    timeElapsed () {
      return secondToHMS(this.timer.timeElapsed / 1000)
    },
    isExam () {
      return MODES.EXAM.includes(this.mode)
    },
    chosenGlossaryName () {
      return this.glossaryList.find((obj) => obj.value === this.chosenGlossary).text
    },
    wordRange () {
      let seqs = this.sortedResult
      let groups = []
      if (seqs.length > 0) {
        let currentGroup = []
        currentGroup.push(seqs[0])
        for (let i = 1; i < seqs.length; i++) {
          if (seqs[i - 1] + 1 === seqs[i]) {
            currentGroup.push(seqs[i])
          } else {
            groups.push(currentGroup)
            currentGroup = []
            currentGroup.push(seqs[i])
          }
          if (i === seqs.length - 1) {
            groups.push(currentGroup)
          }
        }
      }
      let outputStr = ''
      for (const group of groups) {
        if (group.length > 1) {
          outputStr += group[0] + '-' + group[group.length - 1] + ', '
        } else {
          outputStr += group[0] + ', '
        }
      }
      outputStr = outputStr.substring(0, outputStr.length - 2)
      return outputStr
    },
    nowDate () {
      return moment().format('YYYY-MM-DD')
    }
  },
  methods: {
    showModal () {
      this.$bvModal.show(this.modalName)
      this.shown = true

      window.addEventListener('keydown', this.onKeydown)

      if (this.unknownListLength === 0 && this.score === 100) {
        this.playAudio(require('@/assets/Vocabulary/sounds/happy+super.mp3'))
      } else if (this.score >= 90 && this.score < 100) {
        this.playAudio(require('@/assets/Vocabulary/sounds/victory+good.mp3'))
      } else if (this.score >= 80 && this.score < 90) {
        this.playAudio(require('@/assets/Vocabulary/sounds/victory+cool.mp3'))
      } else if (this.score >= 70 && this.score < 80) {
        this.playAudio(require('@/assets/Vocabulary/sounds/loose+soso.mp3'))
      } else if (this.score < 70) {
        this.playAudio(require('@/assets/Vocabulary/sounds/loose+ohoh.mp3'))
      }
    },
    closeModal () {
      window.removeEventListener('keydown', this.onKeydown)
      this.$bvModal.hide(this.modalName)
      this.items = []
      this.shown = false
    },
    onKeydown (event) {
      if (event.repeat) {
        return
      }
      if (this.shown && this.leave && event.key === 'b') {
        this.leaveHandler()
      } else if (this.shown && event.key === 'n') {
        this.nextStep()
      }
    },
    highlight (str) {
      return highlightNumber(str, 26, null, null, 18, '#ffffff', null)
    },
    playAudio (src) {
      if (!src) {
        return
      }
      const audio = new SafeAudio(src)
      audio.play()
      delete audio.audio
    },
    /**
     * 關閉成績 modal 並前往下一步（下一輪新單字或一般學習）
     */
    nextStep () {
      if (MODES.NOTEXAM[0] === this.mode || MODES.FORCEREVIEW === this.mode) { // LEARNNEW || FORCEREVIEW
        if (this.unknownListLength === 0 && this.score === 100) {
          this.resetTimer()
          this.$store.commit('vocabularyPractice/resetAll')
          this.$store
            .dispatch('glossary/checkIfForceReview', { glossary_id: this.chosenGlossary }) // 檢查看是否需要強迫練習
            .then((res) => {
              if (res === 'NOFORCEREVIEW') { // 無需強迫練習則繼續一般程序
                this.$store.commit('vocabularyPractice/setMode', MODES.NOTEXAM[0])
                this.$store
                  .dispatch('glossary/getInitialSequenceAndBlockSize', null)
                  .then((res) => {
                    this.closeModal()
                    this.showQuestionnaireModal()
                  })
              } else if (res === 'COMPLETE') { // 詞庫已學完
                this.$store.commit('vocabularyPractice/setMode', MODES.NOTEXAM[0])
                this.closeModal()
                this.showNotifyCompleteModal()
              } else if (this.userGradeCode !== 18) { // 需要強迫練習
                this.$store.commit('vocabularyPractice/setHasForceReview', true)
                this.$store.commit('vocabularyPractice/setMode', MODES.FORCEREVIEW)
                this.closeModal()
                this.showQuestionnaireModal()
              }
            })
        } else if (this.unknownListLength > 0 || this.score < 100.0) {
          this.closeModal()
          this.showPracticeView()
        }
      } else if (MODES.NOTEXAM[1] === this.mode) {
        if (this.unknownListLength === 0 && this.score === 100) {
          this.resetTimer()
          this.$store.commit('vocabularyPractice/resetAll')
          this.$store
            .dispatch('glossary/getInitialSequenceAndBlockSize', null)
            .then((res) => {
              this.closeModal()
              this.showQuestionnaireModal()
            })
        } else if (this.unknownListLength > 0 || this.score < 100.0) {
          this.closeModal()
          this.showPracticeView()
        }
      } else if (this.mode === 'EXAMSIMULATION' || this.mode === 'EXAM') {
        this.examEndAndLeave()
      }
    },
    examEndAndLeave () {
      this.closeModal()
      this.$store.commit('vocabularyPractice/resetAll')
      this.$store.commit('vocabularyPractice/setLeave', true)
      this.$router.replace('/vocabulary')
    }
  }
}
</script>

<style lang='scss' scoped>
@import "./styles/TestResultModal.scss";
</style>
